import React from "react";
import camelCase from "lodash/camelCase";
import startCase from "lodash/startCase";
import { usePathname } from "next/navigation";

import { DeliveryCopyBlock as DeliveryCopyBlockType } from "@/custom-types/Directus";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import isCanada from "@/utils/isCanada";

import ExpandableContainer from "@/components/botanic/ExpandableContainer";

type Props = {
  className?: string;
  copyBlocks?: DeliveryCopyBlockType["copy_block"];
};

const DeliveryCopyBlock = ({ className, copyBlocks }: Props) => {
  const countryCode = useDomainCountryCode();

  const pathname = usePathname();

  const age = isCanada(countryCode) ? 18 : 21;

  const cityStateArray = (pathname || "")
    .split("/")
    .filter((item) => item !== "")
    .map((word) => startCase(camelCase(word)));
  let header;
  let copy;

  header = "Same-day weed delivery is now available on Leafly!";
  copy = `To start your order, simply enter your address to shop local menus from
    the most reputable and reliable weed delivery services near you. Order
    your favorite THC products for quick delivery including cannabis flower,
    edibles, dabs, pre-rolls, vape pens, cartridges, and accessories.
    Remember, only an adult aged ${age} years old or older can place an order
    for recreational weed delivery, and medical marijuana patients must have
    a valid medical card to place a medical cannabis delivery order.`;
  if (cityStateArray.length === 2) {
    header = `Same-day weed delivery in ${cityStateArray[1]} is now available on Leafly!`;
    copy = `Simply enter your address to shop local menus across ${cityStateArray[1]}
    from the most reputable and reliable weed delivery services. Order your
    favorite THC products for delivery including cannabis flower, edibles, dabs,
    pre-rolls, vape pens, cartridges, and accessories. Remember, only an adult
    aged ${age} years old or older can place an order for weed delivery in ${cityStateArray[1]},
    and medical marijuana patients must have a valid medical card to place a
    medical cannabis delivery order.`;
  }
  if (cityStateArray.length === 3) {
    header = `Same-day weed delivery in ${cityStateArray[2]}, ${cityStateArray[1]} is now available on Leafly!`;
    copy = `Simply enter your address to shop local menus in ${cityStateArray[2]} from the most
      reputable and reliable weed delivery services. Order your favorite THC products for
      delivery including cannabis flower, edibles, dabs, pre-rolls, vape pens, cartridges, and
      accessories. Remember, only an adult aged ${age} years old or older can place
      an order for weed delivery in ${cityStateArray[2]}, and medical marijuana patients must have
      a valid medical card to place a medical cannabis delivery order.`;
  }

  return copyBlocks?.length ? (
    <div className={className}>
      {copyBlocks?.map((block) =>
        block.header && block.copy ? (
          <div className="container my-lg" key={block.header}>
            <h2 className="font-extrabold text-md mb-sm capitalize">
              {block.header}
            </h2>
            <ExpandableContainer initialHeight="105px">
              <div dangerouslySetInnerHTML={{ __html: block.copy }} />
            </ExpandableContainer>
          </div>
        ) : (
          <></>
        ),
      )}
    </div>
  ) : (
    <div className="container my-lg">
      <h2 className="font-extrabold text-md mb-sm">{header}</h2>
      <ExpandableContainer initialHeight="105px">
        <p>{copy}</p>
      </ExpandableContainer>
    </div>
  );
};

export default DeliveryCopyBlock;
